/* eslint-disable react/react-in-jsx-scope */

import {
  AccountsIcon,
  CalendarIcon,
  LogoutIcon,
} from "components/common/ClinicHeader";
import { ICONS } from "components/common/constants/swal.constants";
import GenericModal from "components/common/GenericModal";
import NavHeader, { NavLink } from "components/common/NavHeader";
import useLogout from "components/common/useLogout";
import { useState } from "react";

const links = [
  { pathname: "/impersonation-options", Img: AccountsIcon, name: "Offices" },
  {
    pathname: "/delegate/calendar",
    Img: CalendarIcon,
    name: "QuickView",
  },
];
const Header = () => {
  const [genericModalData, setGenericModalData] = useState({
    show: false,
  });
  const showLogoutSuccess = () => {
    setGenericModalData({
      show: true,
      title: "Goodbye",
      subtext: "See you next time!",
      icon: ICONS.checkMark,
    });
  };
  const showLogoutError = () => {
    setGenericModalData({
      show: true,
      title: "Oops!",
      subtext: "Some error occurred",
      icon: ICONS.error,
    });
  };
  const hideModal = () => {
    setGenericModalData((prevState) => ({ ...prevState, show: false }));
  };

  const logOut = useLogout(
    "/login",
    showLogoutSuccess,
    showLogoutError,
    hideModal
  );

  return (
    <>
      {genericModalData.show && (
        <GenericModal
          show={genericModalData.show}
          onHide={hideModal}
          title={genericModalData?.title || ""}
          subtext={genericModalData?.subtext || ""}
          icon={genericModalData?.icon || undefined}
          hideBtn
        />
      )}
      <NavHeader
        links={links}
        renderLinks={() => {
          return (
            <>
              <NavLink
                Img={LogoutIcon}
                onClick={() => {
                  return logOut();
                }}
                name="Log out"
                data-cy="logout-btn"
              />
            </>
          );
        }}
      />
    </>
  );
};

export default Header;
